import { dialog } from "../../../../nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import DialogModal from "../../../../components/Dialog";
import {
  computePartialCosts,
  computeTotalCost,
} from "../../../../componentCostUtils";
import { auditLogUseCase } from "../../../../usecases/logs";
import { findObjectUseCase } from "../../../../usecases/object";
import Loader from "../../../../components/Loader";
import LoadingState from "../../../../components/LoadingState";

class ReceivableItemFormViewPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    // Preserve raw_materials if present in the view
    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    if (!this.object["dr#"] && this.view.state.object["dr#"]) {
      this.object["dr#"] = [...this.view.state.object["dr#"]];
    }

    if (!this.object.drType && this.view.state.object.drType) {
      this.object.drType = this.view.state.object.drType;
    }

    if (!this.object.remarks && this.view.state.object.remarks) {
      this.object.remarks = this.view.state.object.remarks;
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const paramsView = this.view.getParams();
    console.log("Params", paramsView);
    const id = this.object.id || this.view.getObjectId();

    if (id) {
      const params = {
        include: ["raw_materials", "raw_materials.uom", "uom"],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        // if (this.object.raw_materials) {
        //   this.object.raw_materials = this.object.raw_materials.filter(
        //     (item) => item.sync === "Partial Add" || item.sync === "Not Add"
        //   );
        // }
        console.log("This.object", this.object);
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async save(status) {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    if (this.object.id) {
      this.change.id = this.object.id;
      delete this.change.createdBy;
      this.change.updatedBy = { id: user.id };
    } else {
      this.change.acl = this.view.getAcl();
      delete this.change.updatedBy;
      this.change.createdBy = { id: user.id };
    }

    const toNum = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };

    const rawMaterials = computePartialCosts(
      this.view.state.object.raw_materials || []
    ).map((item) => ({
      ...item,
      totalAmount: String((toNum(item.cost) * toNum(item.quantity)).toFixed(2)),
      sync:
        status === "Draft"
          ? "Not Add"
          : status === "Partially Receive"
          ? item?.quantity !== item?.received
            ? "Partial Add"
            : "Full Add"
          : status === "Received"
          ? item?.quantity === item?.received
            ? "Full Add"
            : ""
          : "",
      added:
        status === "Partially Receive"
          ? toNum(item?.added) + toNum(item?.quantity)
          : 0,
      remaining:
        status === "Partially Receive"
          ? toNum(item?.received) - toNum(item?.added) - toNum(item?.quantity)
          : item?.remaining,
    }));

    this.change.raw_materials = rawMaterials;
    this.change.storeId = { id: user.storeAnalytic[0]?.id };
    this.change.status = status;

    console.log("save", this.change);
    this.change["dr#"] = this.view.state?.object["dr#"];
    this.change.drType = this.view.state?.object?.drType;
    this.change.remarks = this.view.state?.object?.remarks;

    console.log("Raw Materials bEFORE UPDATE: ", this.change);

    const change = this.change;

    if (status === "Partially Receive") {
      let alertMessage = "";
      change.raw_materials.forEach((item) => {
        const added = parseFloat(item.added); // Convert 'added' to number if it's a string
        const remaining =
          parseFloat(item.remaining) - parseFloat(item.quantity); // Convert 'remaining' to number if it's a string
        const received = parseFloat(item.received); // Convert 'received' to number if it's a string

        // Add 'added' and 'remaining', and compare the sum with 'received'
        // if (item?.remaining === 0 && item?.sync === "Partial Add") {
        //   alertMessage = `Item ${item.itemName} has matching total with received quantity. Click "Confirm Fully Receipt" to complete the process.`;
        // }
        if (
          item?.remaining === 0 &&
          (item?.sync === "Partial Add" || item?.sync === "Not Add")
        ) {
          alertMessage = `Item ${item.itemName} has matching total with received quantity. Click "Confirm Fully Receipt" to complete the process.`;
        }
      });

      // If an alert message is set, show the alert
      if (alertMessage) {
        dialog.fire({
          html: (
            <DialogModal
              icon="bi bi-question-octagon-fill"
              iconColor="#82c14a"
              title="Confirm"
              message={alertMessage}
              isCancelButton={false}
              onSubmit={() => {
                // this.view.navigateBack();
                dialog.close();
              }}
              onClose={() => dialog.close()}
            />
          ),
          footer: false,
        });
        return false;
      }
    }

    if (status === "Partially Receive") {
      let alertMessage = "";
      change.raw_materials.forEach((item) => {
        const added = parseFloat(item.added); // Convert 'added' to number if it's a string
        const remaining =
          parseFloat(item.remaining) - parseFloat(item.quantity); // Convert 'remaining' to number if it's a string
        const received = parseFloat(item.received); // Convert 'received' to number if it's a string

        // Add 'added' and 'remaining', and compare the sum with 'received'
        if (item?.remaining !== 0 && item?.sync === "Partial Add") {
          alertMessage = `Item ${item.itemName} has a remaining quantity. Click "Partial Receive" to complete the process.`;
        }
      });

      // If an alert message is set, show the alert
      if (alertMessage) {
        dialog.fire({
          html: (
            <DialogModal
              icon="bi bi-question-octagon-fill"
              iconColor="#82c14a"
              title="Confirm"
              message={alertMessage}
              isCancelButton={false}
              onSubmit={() => {
                // this.view.navigateBack();
                dialog.close();
              }}
              onClose={() => dialog.close()}
            />
          ),
          footer: false,
        });
        return false;
      }
    }

    try {
      const response = await this.upsertUseCase.execute(
        collection,
        this.change
      );
      sessionStorage.removeItem("receivable_items_import");

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Adding Item ${response?.["dr#"]} with status ${status} (s)`,
        collection,
        objectId: response.id,
        payload: {
          request: this.change,
          response: response,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });

      // Handle inventory updates for Partially Receive or Received status
      if (status === "Received" || status === "Partially Receive") {
        // Get previous raw materials if this is an update (for partial->received transitions)
        const previousRawMaterials = this.object.id
          ? this.view.state?.originalObject?.raw_materials || []
          : [];

        await this.updateInventoryFromPackaging(
          rawMaterials,
          user,
          previousRawMaterials
        );
      }

      this.view.hideProgressDialog();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });

      this.change = {};
    } catch (error) {
      throw error;
    }
  }

  /**
   * Updates inventory based on packaging breakdown for received items
   * @param {Array} rawMaterials - Array of raw materials from the delivery receipt
   * @param {Object} user - Current user object
   */
  async updateInventoryFromPackaging(rawMaterials, user) {
    try {
      const toNum = (v) => {
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
      };

      console.log("=== RAW MATERIALS TO PROCESS ===");
      rawMaterials.forEach((item, index) => {
        console.log(
          `${index + 1}. SKU: ${item.sku}, Quantity: ${
            item.quantity
          }, ItemName: ${item.itemName}`
        );
      });

      for (const item of rawMaterials) {
        console.log(
          `\n--- Processing SKU: ${item.sku} with quantity: ${item.quantity} ---`
        );

        // Check if SKU exists in packaging_breakdowns collection
        const packagingBreakdownArray = await this.findPackagingBreakdown(
          item.sku
        );

        console.log(
          `Packaging breakdown result for ${item.sku}:`,
          packagingBreakdownArray
        );

        // Handle the array response - take the first item if it exists
        const packagingBreakdown =
          Array.isArray(packagingBreakdownArray) &&
          packagingBreakdownArray.length > 0
            ? packagingBreakdownArray[0]
            : packagingBreakdownArray;

        if (packagingBreakdown && packagingBreakdown.raw_materials) {
          console.log(`Found packaging breakdown for SKU: ${item.sku}`);

          // CRITICAL: Verify the packaging breakdown matches the requested SKU
          if (packagingBreakdown.sku !== item.sku) {
            console.error(`ERROR: Packaging breakdown SKU mismatch!`);
            console.error(
              `  Requested SKU: ${item.sku} (quantity: ${item.quantity})`
            );
            console.error(`  Found packaging SKU: ${packagingBreakdown.sku}`);
            console.error(
              `  This means ${item.sku} doesn't have its own packaging breakdown!`
            );
            console.error(
              `  Skipping this item to prevent wrong calculations.`
            );
            continue; // Skip to prevent wrong calculations
          }

          console.log(
            `✅ Verified correct packaging breakdown for ${item.sku}`
          );
          console.log(
            `Using item quantity: ${item.quantity} (not packaging quantity)`
          );
          console.log(
            `Packaging raw materials:`,
            packagingBreakdown.raw_materials.map((rm) => ({
              sku: rm.sku,
              itemName: rm.itemName,
              multiplier: rm.quantity,
            }))
          );

          // Process each raw material in the packaging breakdown
          for (const packagingRawMaterial of packagingBreakdown.raw_materials) {
            // IMPORTANT: Use item.quantity (delivery quantity), not packagingRawMaterial.quantity
            const deliveryQuantity = toNum(item.quantity);
            const packagingMultiplier = toNum(packagingRawMaterial.quantity);
            const adjustedQuantity = deliveryQuantity * packagingMultiplier;

            console.log(
              `Inventory calculation for ${packagingRawMaterial.sku}:`
            );
            console.log(`  Source SKU: ${item.sku}`);
            console.log(
              `  Delivery Quantity: ${deliveryQuantity} (from delivery receipt)`
            );
            console.log(
              `  Packaging Multiplier: ${packagingMultiplier} (from packaging breakdown)`
            );
            console.log(
              `  Final Amount: ${deliveryQuantity} × ${packagingMultiplier} = ${adjustedQuantity}`
            );

            console.log("BEFORE ADD TO INVENTORY: ", item);
            // if (item?.sync === "Not Add" || item?.sync === "Partial Add") {
            console.log("WORKING!!!!!");
            // Add to inventory collection
            await this.addToInventory({
              sku: packagingRawMaterial.sku,
              itemName: packagingRawMaterial.itemName,
              systemCount: String(adjustedQuantity),
              storeId: user,
              adjustedBy: user,
              sourceSku: item.sku,
              sourceQuantity: deliveryQuantity,
              packagingMultiplier: packagingMultiplier,
            });
            // }
          }

          // dialog.fire({
          //   html: (
          //     <DialogModal
          //       icon="bi bi-question-octagon-fill"
          //       iconColor="#82c14a"
          //       title="Saved Successfully"
          //       message=""
          //       isCancelButton={false}
          //       onSubmit={() => {
          //         this.view.navigateBack();
          //         dialog.close();
          //       }}
          //       onClose={() => dialog.close()}
          //     />
          //   ),
          //   footer: false,
          // });
        } else {
          console.log(`❌ No packaging breakdown found for SKU: ${item.sku}`);
          console.log(
            `This means ${item.sku} doesn't exist in packaging_breakdowns collection`
          );
          console.log(
            `You need to create a packaging breakdown for ${item.sku} in the database`
          );
        }
      }
    } catch (error) {
      console.error("Error updating inventory from packaging:", error);
      throw error;
    }
  }

  /**
   * Find packaging breakdown by SKU
   * @param {string} sku - SKU to search for
   * @returns {Object|null} Packaging breakdown object or null if not found
   */
  async findPackagingBreakdown(sku) {
    try {
      console.log(`Searching packaging breakdown for SKU: ${sku}`);

      const query = {
        where: {
          sku: sku,
        },
      };

      console.log(`Query:`, query);

      const result = await findObjectUseCase().execute(
        "packaging_breakdowns",
        query
      );

      console.log(`Raw query result for ${sku}:`, result);

      // Validate result
      if (result && Array.isArray(result) && result.length > 0) {
        const firstResult = result[0];
        if (firstResult.sku !== sku) {
          console.error(
            `Query returned wrong SKU! Requested: ${sku}, Got: ${firstResult.sku}`
          );
        }
      }

      return result;
    } catch (error) {
      console.error(`Error finding packaging breakdown for SKU ${sku}:`, error);
      return null;
    }
  }

  /**
   * Add item to inventory collection
   * @param {Object} inventoryItem - Item to add to inventory
   */
  async addToInventory(inventoryItem) {
    console.log("\n=== ADDING TO INVENTORY ===");
    console.log("Inventory Item Details:");
    console.log(`  Target SKU: ${inventoryItem.sku}`);
    console.log(`  Target Item: ${inventoryItem.itemName}`);
    console.log(`  Amount to Add: ${inventoryItem.systemCount}`);
    console.log(`  Source SKU: ${inventoryItem.sourceSku}`);
    console.log(`  Source Quantity: ${inventoryItem.sourceQuantity}`);
    console.log(`  Packaging Multiplier: ${inventoryItem.packagingMultiplier}`);
    console.log(
      `  Calculation: ${inventoryItem.sourceQuantity} × ${inventoryItem.packagingMultiplier} = ${inventoryItem.systemCount}`
    );

    try {
      // Check if item already exists in inventory
      const existingInventoryArray = await this.findExistingInventory(
        inventoryItem.sku,
        inventoryItem.itemName,
        inventoryItem?.storeId?.storeAnalytic[0]?.id
      );

      // Handle the array response - take the first item if it exists
      const existingInventory =
        Array.isArray(existingInventoryArray) &&
        existingInventoryArray.length > 0
          ? existingInventoryArray[0]
          : null;

      console.log(
        "Existing inventory:",
        existingInventory
          ? {
              id: existingInventory.id,
              sku: existingInventory.sku,
              itemName: existingInventory.itemName,
              currentStock: existingInventory.systemCount,
            }
          : "None found"
      );

      if (existingInventory) {
        // Update existing inventory quantity
        const toNum = (v) => {
          const n = parseFloat(v);
          return Number.isFinite(n) ? n : 0;
        };

        const previousQuantity = toNum(existingInventory.systemCount);
        const addedQuantity = toNum(inventoryItem.systemCount);
        const updatedQuantity = previousQuantity + addedQuantity;

        console.log("Stock update:");
        console.log(`  Current Stock: ${previousQuantity}`);
        console.log(`  Adding: ${addedQuantity}`);
        console.log(`  New Total: ${updatedQuantity}`);

        const updatedResult = await this.upsertUseCase.execute("inventory", {
          id: existingInventory.id,
          systemCount: String(updatedQuantity),
          adjustedBy: { id: inventoryItem.adjustedBy?.id },
          lastAdjusted: new Date().toISOString(),
        });

        console.log(
          `✅ Successfully updated inventory for ${inventoryItem.sku}: ${updatedQuantity}`
        );

        // Create inventory log for the update
        await this.createInventoryLog({
          user: { id: inventoryItem?.adjustedBy?.id },
          itemName: inventoryItem?.itemName,
          adjustmentType: "Delivery || Receivable",
          oldQuantity: previousQuantity.toString(),
          newQuantity: updatedQuantity.toString(),
          storeId: { id: inventoryItem?.storeId?.storeAnalytic?.[0]?.id },
          sku: inventoryItem.sku,
        });
      } else {
        console.log(
          `❌ No existing inventory found for ${inventoryItem.sku}. Skipping creation.`
        );
      }
    } catch (error) {
      console.error(
        `Error adding to inventory for SKU ${inventoryItem.sku}:`,
        error
      );
      throw error;
    }
  }

  /**
   * Create inventory log entry
   * @param {Object} logData - Data for inventory log
   */
  async createInventoryLog(logData) {
    try {
      const inventoryLogData = {
        user: logData?.user,
        itemName: logData?.itemName,
        adjustmentType: logData?.adjustmentType,
        oldQuantity: logData?.oldQuantity,
        newQuantity: logData?.newQuantity,
        storeId: logData?.storeId,
        sku: logData?.sku,
      };

      await this.upsertUseCase.execute("inventory_logs", inventoryLogData);
      console.log(
        `Created inventory log for ${logData.sku} - Action: ${logData.adjustmentType}`
      );
    } catch (error) {
      console.error(
        `Error creating inventory log for SKU ${logData.sku}:`,
        error
      );
      throw error;
    }
  }

  /**
   * Create audit log entry for inventory changes
   * @param {Object} auditData - Data for audit log
   */
  async createInventoryAuditLog(auditData) {
    try {
      const auditLogData = {
        user: auditData?.user,
        logDate: auditData?.logDate,
        message: auditData?.message,
        collection: auditData?.collection,
        objectId: auditData?.objectId,
        payload: auditData?.payload,
        store: auditData?.store,
      };

      await auditLogUseCase().create(auditLogData);
      console.log(
        `Created audit log for inventory ${auditData.action} - SKU: ${auditData.sku}`
      );
    } catch (error) {
      console.error(
        `Error creating audit log for SKU ${auditData.sku}:`,
        error
      );
      throw error;
    }
  }

  /**
   * Find existing inventory item
   * @param {string} sku - SKU to search for
   * @param {string} itemName - Item name
   * @param {string} storeId - Store ID
   * @returns {Object|null} Existing inventory item or null
   */
  async findExistingInventory(sku, itemName, storeId) {
    try {
      const query = {
        where: {
          sku: sku,
          itemName: itemName,
          "storeId.id": { $eq: storeId },
        },
      };
      const result = await findObjectUseCase().execute("inventory", query);
      return result;
    } catch (error) {
      console.error(`Error finding existing inventory for SKU ${sku}:`, error);
      return null;
    }
  }

  async submit(status) {
    try {
      this.view.submitting();
      dialog.close();
      await this.save(status);

      // dialog.fire({
      //   html: (
      //     <DialogModal
      //       icon="bi bi-question-octagon-fill"
      //       iconColor="#82c14a"
      //       title="Saved Successfully"
      //       message=""
      //       isCancelButton={false}
      //       onSubmit={() => {
      //         this.view.navigateBack();
      //         dialog.close();
      //       }}
      //       onClose={() => dialog.close()}
      //     />
      //   ),
      //   footer: false,
      // });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default ReceivableItemFormViewPresenter;
